/**
 * Created by andrey on 11.06.2024
 */

const VirtualResource = function (bundleName, key) {
    this.bundleName = bundleName;
    this.key = key;
};

cc.VirtualResource = VirtualResource;

VirtualResource.prototype.onUnload = function () {
};

VirtualResource.prototype.toString = function () {
    return `${this.bundleName}[${this.key}]`;
};

VirtualResource.prototype.getInjectTo = function (preferredBundles) {
    const bundle = bundles[this.bundleName];
    if (!bundle.virtual) {
        return [this.bundleName];
    }

    const injectToSet = bundle.injectToSet;

    if (cc.rendererBundle && injectToSet[cc.rendererBundle] && bundles[cc.rendererBundle].loaded) {
        return [cc.rendererBundle];
    }

    if (preferredBundles && preferredBundles.length > 0) {
        preferredBundles = preferredBundles.filter((name) => {
            const bundle = bundles[name];
            return injectToSet[name] && !bundle.virtual && bundle.loaded;
        });

        if (preferredBundles.length > 0) {
            return preferredBundles;
        }
    }

    return bundle.injectTo;
};

VirtualResource.prototype.resolve = function (preferredBundles) {
    if (!this.bundleName) {
        return this;
    }
    const bundle = bundles[this.bundleName];
    if (!bundle.virtual) {
        return this;
    }

    let collection = "frames";
    if (this instanceof VirtualJson) {
        collection = "jsons";
    } else if (this instanceof VirtualUrl || this instanceof SoundFrame) {
        collection = "urls";
    }

    const injectTo = this.getInjectTo(preferredBundles);
    let loaded = false;
    for (let i = 0; i < injectTo.length; ++i) {
        const bundleName = injectTo[i];
        if (cleverapps.bundleLoader.isLoaded(bundleName) || cleverapps.lazyAssets.isPreferredBundle(bundleName)) {
            const resource = bundles[bundleName][collection][this.key];
            if (resource) {
                return resource;
            }
            loaded = true;
        }
    }

    if (!loaded) {
        const message = `${this.toString()} not loaded  - ${injectTo.join(";")}`;
        if (cleverapps.config.debugMode) {
            throw new Error(message);
        } else {
            cleverapps.throwAsync(message);
        }
    }
};

VirtualResource.prototype.originalPath = function () {
    const bundle = bundles[this.bundleName];
    return bundle.meta.originalPaths && bundle.meta.originalPaths[this.key];
};

VirtualResource.prototype.isLazy = function () {
    const meta = bundles[this.bundleName].meta;
    return meta && meta.lazy && meta.lazy[this.key];
};

VirtualResource.prototype.isBundleLazy = function () {
    return bundles[this.bundleName].lazy;
};

VirtualResource.prototype.getBundleName = function () {
    return this.bundleName;
};

VirtualResource.prototype.isLoaded = function () {
    return bundles[this.bundleName].isLoaded();
};

VirtualResource.prototype.getDimensions = function () {
    const meta = bundles[this.bundleName].meta;
    const size = meta && meta.sizes && meta.sizes[this.key];
    if (size) {
        return cc.size(size.width * resolutionScale, size.height * resolutionScale);
    }
};

VirtualResource.prototype.getAnchors = function () {
    const meta = bundles[this.bundleName].meta;
    return meta && meta.anchors && meta.anchors[this.key];
};

VirtualResource.prototype.getUrl = function () {
    
};

VirtualResource.prototype.save = function () {
    
};
